import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Constants from 'root/constants';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Form from 'root/module/form';
import Modals from 'root/modals';
import View from 'root/view/base';
import Model_Integration_Asana from 'root/model/integration_asana';

var Asana_Edit = View.extend({
    app_id: 0,

    send_options : null,

    access_token  : '',
    refresh_token : '',
    expires_at    : 0,

    project_id    : '',
    assignee      : '',
    is_auto       : false,
    auto_resolve  : false,
    feedback_type : '',

    is_new        : false,

    events: {
        'click .app-add'               : 'onAddApp',
        'click .dropdown-app li'       : 'onSelectApp',
        'click .dropdown-workspace li' : 'onSelectWorkspace',
        'click .dropdown-project li'   : 'onSelectProject',
        'click .dropdown-assignee li'  : 'onSelectAssignee',
        'click .dropdown-auto-send li' : 'onSelectAutoSend',
        'click .reconnect'             : 'onReconnect',
        'submit form'                  : 'onSubmit'
    },

    dom_handlers: {
        onAddApp: function(e) {
            Modals.oauthAsana((access_token, refresh_token, expires_at) => {
                Cache.app.request({
                    action: 'integration/addConnectedApp',
                    data: {
                        type          : 'asana',
                        access_token  : access_token,
                        refresh_token : refresh_token,
                        expires_at    : expires_at
                    },
                    success: (response) => {
                        Cache.connected_app_oauth.add(response);

                        if (this.model.isConnected()) {
                            Modals.editAsana();
                        } else {
                            Modals.activateAsana();
                        }
                    }
                });
            });
        },

        onSelectApp: function(e) {
            this.app_id = parseInt($(e.currentTarget).data('val'), 10);

            // reset everyting
            this.send_options = null;
            this.project_id   = '';

            this.update(); // render loader

            this.loadOptions();
        },

        onSelectWorkspace: function(e) {
            var workspace_name = $(e.currentTarget).text();

            this.project_id = '';
            this.assignee   = '';

            this.send_options.projects.forEach((project) => {
                if (!this.project_id && project.workspace === workspace_name) {
                    this.project_id = project.id;
                }
            });

            this.update();
        },

        onSelectProject: function(e) {
            this.project_id = $(e.currentTarget).data('id');
            this.update();
        },

        onSelectAssignee: function(e) {
            this.assignee = $(e.currentTarget).data('val');
            this.update();
        },

        onSelectAutoSend: function(e) {
            this.is_auto      = $(e.currentTarget).data('is_auto')      == 1 ? true : false;
            this.auto_resolve = $(e.currentTarget).data('auto_resolve') == 1 ? true : false;
            this.update();
        },

        onReconnect: function(e) {
            var connected_app = Cache.connected_app_oauth.get(this.app_id);

            if (connected_app) {
                Modals.reconnectConnectedApp(connected_app.get('app_type'), connected_app, () => {
                    Modals.editAsana();
                });
            } else {
                // TODO:?
            }
        },

        onSubmit: function(e) {
            if (!this.project_id) {
                return;
            }

            var form_data = Form.getData(this.$el.find('form'));
            this.feedback_type = form_data.feedback_type.join(',');

            var data = {
                app_id             : this.app_id,
                asana_project_id   : this.project_id,
                assignee           : this.assignee,
                is_auto            : this.is_auto,
                auto_resolve       : this.auto_resolve,
                feedback_type      : this.feedback_type,
            };

            this.$el.find('button:submit').addClass('loading').prop('disabled', false);

            Cache.app.request({
                action: this.is_new ? 'integration/activate' : 'integration/update',
                data: {...data,
                    type          : 'asana',
                    access_token  : this.access_token,
                    refresh_token : this.refresh_token,
                    expires_at    : this.expires_at
                },
                context: this,
                success: function(response) {
                    if (this.access_token) {
                        Cache.connected_app_oauth.add(response.connected_app_oauth);
                    }

                    this.model.set(response.data);

                    if (this.is_new) {
                        Cache.integration_asana.add(this.model);
                        UI.success('Asana integration activated');
                        Cache.app.trackEvent('Integration Added', { integration: 'Asana' });
                    } else {
                        UI.success('Asana integration updated');
                    }

                    this.trigger('submit:success');
                },
                complete: function() {
                    this.$el.find('button:submit').removeClass('loading').prop('disabled', false);
                }
            });
        }
    },

    searchUser: function(user_id) {
        var result = false;

        if (this.send_options) {
            this.send_options.users.forEach(function(user) {
                if (user.id == user_id) {
                    result = user;
                }
            });
        }

        return result;
    },

    searchProject: function(project_id) {
        var result = false;

        if (this.send_options) {
            this.send_options.projects.forEach(function(project) {
                if (project.id == project_id) {
                    result = project;
                }
            });
        }

        return result;
    },

    searchWorkspace: function(project_id) {
        var result = '';

        if (this.send_options) {
            var project = this.searchProject(project_id);

            if (project) {
                this.send_options.workspaces.forEach((workspace) => {
                    if (workspace.name === project.workspace) {
                        result = workspace
                    }
                });
            }
        }

        return result;
    },

    initialize: function(options) {
        this.app_id        = options.app_id        || 0;
        this.access_token  = options.access_token  || '';
        this.refresh_token = options.refresh_token || '';
        this.expires_at    = options.expires_at    || 0;
        this.is_new        = !!options.is_new;

        this.model = Cache.integration_asana.findWhere({project_id: Cache.default_project_id}) || new Model_Integration_Asana({
            account_id: Cache.account.get('id'),
            project_id: Cache.default_project_id
        });

        if (this.is_new) {
            this.feedback_type = [Constants.FEEDBACK_BUG, Constants.FEEDBACK_FEATURE_REQUEST, Constants.FEEDBACK_GENERAL].join(',');
        } else {
            this.app_id        = this.model.get('app_id');
            this.project_id    = this.model.get('asana_project_id');
            this.assignee      = this.model.get('asana_assignee');
            this.is_auto       = this.model.get('is_auto');
            this.auto_resolve  = this.model.get('auto_resolve');
            this.feedback_type = this.model.get('feedback_type');
        }
    },

    loadOptions: function() {
        Cache.app.request({
            action: 'integration/loadSendOptions',
            data: {
                type         : 'asana',
                app_id       : this.app_id,
                access_token : this.access_token
            },
            context: this,
            success: function(response) {
                if (response.workspaces && response.workspaces.length) {
                    this.send_options = response;

                    var project  = this.searchProject(this.project_id);
                    var assignee = this.searchUser(this.assignee);

                    if (!project) {
                        this.project_id = this.send_options.projects.length ? this.send_options.projects[0].id : 0;
                    }

                    if (!assignee) {
                        this.assignee = '';
                    }

                    this.update();
                } else {
                    this.renderError();
                }
            },
            error: function() {
                this.renderError();
            }
        });
    },

    renderError: function() {
        var connected_app = Cache.connected_app_oauth.get(this.app_id);

        var html = '<div class="error-dialog padding-30">' +
                       '<div class="icon"><i class="fas fa-exclamation"></i></div>' +
                       '<h3>Authentication failed</h3>' +
                       (connected_app ?
                       '<p class="info">Your Asana account (<a class="navigation" href="/account/connected_app">' + connected_app.escape('custom_name') + '</a>) couldn\'t be connected.</p>' :
                       '<p class="info">Your Asana account couldn\'t be connected.</p>') +
                       '<button class="reconnect primary medium">Reconnect Asana</button>' +
                   '</div>';

        this.$el.html(html);
    },

    update: function() {
        var app_items          = '';
        var workspace_items    = '';
        var project_items      = '';
        var user_items         = '';

        var app_selected       = Cache.connected_app_oauth.get(this.app_id);
        var project_selected   = this.searchProject(this.project_id);
        var user_selected      = this.searchUser(this.assignee);
        var workspace_selected = this.searchWorkspace(this.project_id);

        if (this.send_options) {
            if (!workspace_selected) {
                workspace_selected = this.send_options.workspaces[0];
            }

            this.send_options.workspaces.forEach((workspace) => {
                workspace_items += '<li data-val="' +  workspace.gid + '"' + (workspace_selected && workspace_selected.gid === workspace.gid ? ' class="selected"' : '') + '>' + Util.htmlEntities(workspace.name) + '</li>';
            });

            this.send_options.projects.forEach((project) => {
                if (project.workspace === workspace_selected.name) {
                    project_items += '<li class="project' + (this.project_id == project.id ? ' selected' : '') + '" data-id="' + project.id + '"' + '>' + Util.htmlEntities(project.name) + '</li>';
                }
            });

            this.send_options.users.forEach((user) => {
                if (user.workspace === workspace_selected.name) {
                    user_items += '<li data-val="' + user.id + '"' + (this.assignee == user.id ? ' class="selected"' : '') + '>' +
                                      Util.htmlEntities(user.name) +
                                  '</li>';
                }
            });
        }

        Cache.connected_app_oauth.where({app_type: 'asana'}).forEach((model) => {
            var integration_total = model.get('integration_total') || 0;

            app_items += '<li data-val="' + model.id + '"' + (model.id === this.app_id ? ' class="active"' : '') + '>' +
                             '<img class="icon-img" src="/image/asana_small.png">' +
                             '<span class="font-weight-medium">' + model.escape('custom_name') + '</span>' +
                             '<div class="text-info margin-top-4">' +
                                 '<div class="icon-img"></div>' +
                                 'Connected on: ' + Util.moment(model.get('create_time')) +
                                 (model.isDisabled() ? '<span class="badge-warning-invert badge-small margin-left-4">Expired</span>' : '') +
                             '</div>' +
                             '<div class="text-info margin-top-4">' +
                                 '<div class="icon-img"></div>' +
                                 'Used in ' + integration_total + ' integration' + (integration_total === 1 ? '' : 's') +
                             '</div>' +
                         '</li>';
        });

        var content =
        '<div class="grid-4-8">' +
            '<div><h5>Asana Settings</h5></div>' +
            '<div>' +
                (Cache.connected_app_oauth.where({app_type: 'asana'}).length ?
                '<div class="row">' +
                    '<div class="field-label">Connection</div>' +
                    '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-app">' +
                        '<button type="button" class="dropdown-select dropdown-select-medium"><img class="icon-img" src="/image/asana_small.png">' + (app_selected ? app_selected.escape('custom_name') : '') + '</button>' +
                        '<div>' +
                            '<ul class="dropdown">' + app_items + '</ul>' +
                            '<div>' +
                                '<button type="button" class="app-add text-link small"><i class="fa-solid fa-plus margin-right-4"></i>Add connection</button>' +
                                '<button type="button" class="navigation text-link small float-right tooltip" data-title="Manage my apps" data-offset="0,10" href="/account/connected_app"><i class="fa-solid fa-cog"></i></button>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>' : '') +
                '<div class="row">' +
                    '<div class="field-label">Workspace</div>' +
                    (this.send_options ?
                    '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-workspace">' +
                        '<button type="button" class="dropdown-select dropdown-select-medium">' + (workspace_selected ? Util.htmlEntities(workspace_selected.name) : '<span class="text-info">No workspace selected</span>') + '</button>' +
                        '<div>' +
                            '<div class="dropdown-search">' +
                                '<input type="text" class="solid compact" placeholder="Search by workspace name">' +
                            '</div>' +
                            '<ul class="dropdown dropdown-select" data-empty="No workspaces found">' + workspace_items + '</ul>' +
                        '</div>' +
                    '</div>' : '<div class="loader-placeholder-regular"></div>') +
                '</div>' +
                '<div class="row">' +
                    '<div class="field-label">Project</div>' +
                    (this.send_options ?
                    '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-project">' +
                        '<button type="button" class="dropdown-select dropdown-select-medium">' + (project_selected ? Util.htmlEntities(project_selected.name) : '<span class="text-info">No project selected</span>') + '</button>' +
                        '<div>' +
                            '<div class="dropdown-search">' +
                                '<input type="text" class="solid compact" placeholder="Search by project name">' +
                            '</div>' +
                            '<ul class="dropdown dropdown-select" data-empty="No projects found">' + project_items + '</ul>' +
                        '</div>' +
                    '</div>' : '<div class="loader-placeholder-regular"></div>') +
                '</div>' +
                '<div class="row">' +
                    '<div class="field-label">Default Assignee</div>' +
                    (this.send_options ?
                    '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-assignee">' +
                        '<button type="button" class="dropdown-select dropdown-select-medium">' + (user_selected ? Util.htmlEntities(user_selected.name) : '<span class="text-info">No assignee selected</span>') + '</button>' +
                        '<div>' +
                            '<div class="dropdown-search">' +
                                '<input type="text" class="solid compact" placeholder="Search by name">' +
                            '</div>' +
                            '<ul class="dropdown dropdown-select" data-empty="No assignees found">' + user_items + '</ul>' +
                        '</div>' +
                    '</div>' : '<div class="loader-placeholder-regular"></div>') +
                '</div>' +
            '</div>' +
        '</div>' +
        '<hr>' +
        '<div class="grid-4-8">' +
            '<div><h5>Automation</h5></div>' +
            '<div>' +
                '<div class="row">' +
                    '<div class="field-label">Send feedback to Asana</div>' +
                    '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-auto-send">' +
                        '<button type="button" class="dropdown-select dropdown-select-medium">' +
                            (this.auto_resolve ? 'Automatically and resolve in Userback' : (this.is_auto ? 'Automatically' : 'Manually')) +
                        '</button>' +
                        '<div>' +
                            '<ul class="dropdown dropdown-select large">' +
                                '<li data-is_auto="0" data-auto_resolve="0"' + (!this.auto_resolve && !this.is_auto ? ' class="selected"' : '') + '>Manually</li>' +
                                '<li data-is_auto="1" data-auto_resolve="0"' + (!this.auto_resolve && this.is_auto ? ' class="selected"' : '') + '>Automatically</li>' +
                                '<li data-is_auto="1" data-auto_resolve="1"' + (this.auto_resolve ? ' class="selected"' : '') + '>Automatically and resolve in Userback</li>' +
                            '</ul>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div class="row">' +
                    '<div class="field-label">Select feedback type <i class="fas fa-question-circle info tooltip" data-title="Select what type of feedback to be sent to Asana automatically"></i></div>' +
                    '<div>' +
                        '<input type="checkbox" name="feedback_type" value="' + Constants.FEEDBACK_BUG + '"' + (this.feedback_type.indexOf(Constants.FEEDBACK_BUG.toString()) === -1 ? '' : ' checked') + '><label>Bug</label>' +
                        '<input type="checkbox" name="feedback_type" value="' + Constants.FEEDBACK_FEATURE_REQUEST + '"' + (this.feedback_type.indexOf(Constants.FEEDBACK_FEATURE_REQUEST.toString()) === -1 ? '' : ' checked') + '><label>Idea</label>' +
                        '<input type="checkbox" name="feedback_type" value="' + Constants.FEEDBACK_GENERAL + '"' + (this.feedback_type.indexOf(Constants.FEEDBACK_GENERAL.toString()) === -1 ? '' : ' checked') + '><label>General Feedback</label>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>';

        this.$el.find('.form-main').html(content);
        this.$el.find('button:submit').prop('disabled', this.project_id ? false : true);
        this.$el.find('input[name="feedback_type"]').prop('disabled', !this.is_auto);
    },

    render: function() {
        var content =
        '<form class="form-fluid">' +
            '<div class="form-main">' +
                '<div class="grid-4-8">' +
                    '<div><div class="loader-placeholder" style="width:100px;"></div></div>' +
                    '<div>' +
                        (Cache.connected_app_oauth.where({app_type: 'asana'}).length ?
                        '<div class="loader-placeholder-small margin-bottom-8" style="width:100px;"></div>'  +
                        '<div class="loader-placeholder-regular margin-bottom-20"></div>' : '') +
                        '<div class="loader-placeholder-small margin-bottom-8" style="width:100px;"></div>'  +
                        '<div class="loader-placeholder-regular margin-bottom-20"></div>' +
                        '<div class="loader-placeholder-small margin-bottom-8" style="width:100px;"></div>'  +
                        '<div class="loader-placeholder-regular margin-bottom-20"></div>' +
                        '<div class="loader-placeholder-small margin-bottom-8" style="width:100px;"></div>'  +
                        '<div class="loader-placeholder-regular"></div>' +
                    '</div>' +
                '</div>' +
                '<hr>' +
                '<div class="grid-4-8">' +
                    '<div><div class="loader-placeholder" style="width:100px;"></div></div>' +
                    '<div>' +
                        '<div class="loader-placeholder-small margin-bottom-8" style="width:100px;"></div>'  +
                        '<div class="loader-placeholder-regular"></div>'  +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<hr>' +
            '<div class="sidebar-bottom' + (this.is_new ? ' animated' : '') + '">' +
                '<button type="submit" class="primary" disabled>' + (this.is_new ? 'Complete Setup' : 'Save Changes') + '</button>' +
            '</div>' +
        '</form>';

        this.$el.html(content);

        if (!this.send_options) {
            this.loadOptions();
        }

        return this;
    }
});

export default Asana_Edit;